export const basePath = 'assessment';
export const adminPath = 'admin';
